module.exports = __webpack_public_path__ + "static/media/icon_bus_stop_collision.c54497ed.png";